import React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import ReactExport from 'react-export-excel';
import { Icon } from '@iconify/react';
import { fDateTime } from '../../utils/formatTime';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

function ReporteExcelButton({ dataList = [], usersIdList = [], notSort = false }) {
  if (dataList.length > 0) {
    const sortedArr = dataList.map((obj) => {
      const sortedKeys = notSort ? Object.keys(obj) : Object.keys(obj).sort();
      const sortedObj = {};

      sortedKeys.forEach((key) => {
        if (key === 'items' && Array.isArray(obj.items)) {
          sortedObj[key] = obj[key]
            .map((item) => Object.fromEntries(Object.entries(item).sort()))
            .map((item) => {
              const cantidad = item.cantidad ? `Cantidad: ${item.cantidad}` : '';
              const description = item.description ? `Description: ${item.description}` : '';
              return [cantidad, description].filter(Boolean).join(', ');
            })
            .join('; ');
        } else {
          // console.log({ fromElse: key });
          sortedObj[key] = obj[key];
          if (key === 'created_at' || key === 'updated_at') {
            sortedObj[key] = fDateTime(sortedObj[key].toDate());
          }
          if (usersIdList.length > 0) {
            if (key === 'userId') {
              const matchingUser = usersIdList.find((user) => user.id === obj.userId);
              const matchingHost = usersIdList.find((user) => user.id === obj.hostUserId);
              sortedObj.displayName = matchingUser ? matchingUser.displayName : obj[key];
              sortedObj.displayHostName = matchingHost ? matchingHost.displayName : obj[key];
            }
          }
        }
        delete sortedObj.userId;
        delete sortedObj.hostUserId;
      });
      return sortedObj;
    });
    // console.log({ sortedArr });
    const keys = Object.keys(sortedArr[0]);

    const columns = keys.map((key) => key.charAt(0).toUpperCase() + key.slice(1));
    const data = sortedArr.map((obj) => Object.values(obj));
    const optimizedMultiDataSet = [{ columns, data }];

    return (
      <ExcelFile
        element={
          <Tooltip title="Generar reporte">
            <IconButton>
              <Icon icon="vscode-icons:file-type-excel" />
            </IconButton>
          </Tooltip>
        }
      >
        <ExcelSheet dataSet={optimizedMultiDataSet} name="Organization" />
      </ExcelFile>
    );
  }
  return <p>No hay nada por el momento</p>;
}

export default ReporteExcelButton;
